import { useBrandProfile } from 'hooks/queries/workspaces/useBrandProfile'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'

const CACHE_TIME_MS = 5 * 60 * 1000

export const useAutopilotBrandKit = () => {
  const { data: brandProfile, isLoading: isLoadingProfile } = useBrandProfile({ cacheTime: CACHE_TIME_MS })

  const brandKitId = brandProfile?.brand_kit?.id

  const { data: brandKitData, isLoading: isLoadingBrandKit } = useBrandKit(brandKitId, {
    cacheTime: CACHE_TIME_MS,
    includeBrandVisualAnalysis: true,
  })

  const brandKit = brandKitData?.brand_kit
  const brandVisualKitId = brandKit?.brand_visual_kit?.id

  return {
    brandProfile,
    brandKitId,
    brandKit,
    brandVisualKitId,
    isLoadingProfile,
    isLoadingBrandKit,
  }
}
